/* AITO — the media-feature video control.
   Only the media-feature section has a <video>, so this rode in the shared
   bundle on every page that has none. The section now loads it itself. */
(function () {
  "use strict";

  /* ---------------- motion video (pause control + reduced motion) ---------------- */
  function initMotionVideo() {
    document.querySelectorAll(".motion").forEach(function (sec) {
      var video = sec.querySelector("video");
      var btn = sec.querySelector("[data-motion-toggle]");
      if (!video || !btn) return;
      function setState(playing) {
        btn.setAttribute("aria-pressed", playing ? "false" : "true");
        btn.setAttribute("aria-label", playing ? "Pause video" : "Play video");
        sec.classList.toggle("motion--paused", !playing);
      }
      btn.addEventListener("click", function () {
        if (video.paused) { video.play(); setState(true); }
        else { video.pause(); setState(false); }
      });
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        video.pause(); video.removeAttribute("autoplay"); setState(false);
      } else setState(true);
    });
  }
  
  /* ---------------- quick-add reveal on touch (p13) ----------------
     On hover devices CSS handles everything. On touch there is no hover, and
     showing every card's sizes permanently turned the grid into a wall of black
     slabs. The sizes now open over the image only when asked, one card at a
     time, and close on outside tap or Escape. */

  function boot() {
    try { initMotionVideo(); }
    catch (err) { if (window.console && console.error) console.error("aito motion video failed:", err); }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
